import React, { useState, useEffect, useContext } from "react";
import SettingTable from "../ManageSettings/SettingTable";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../.././../utils/secure-route/AuthContext";
import { ToastContainer } from "react-toastify";
import prepaid from "../../../../assets/Image/prepaid.png";
import CloseIcon from "../../../../assets/Image/close.png";
import { useToastHandler } from "../../../common/ToastHandler";
import { message } from "antd";
export default function GeneralLedgerSalesTax() {

  const [tax, setTax] = useState([]);
  const { Post } = useApi();
  const { user } = useContext(AuthContext);
  const { handleToast } = useToastHandler();
  const [selectedMonth, setSelectedMonth] = useState(
    getCurrentDateInfo("month")
  );
  const [selectedYear, setSelectedYear] = useState(getCurrentDateInfo("year"));
  const storeid = user.store;

  function getCurrentDateInfo(type) {
    const currentDate = new Date();

    if (type === "month") {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return monthNames[currentDate.getMonth()]; 
    } else if (type === "year") {
      return currentDate.getFullYear().toString(); 
    } else {
      return "Invalid type. Use 'month' or 'year'.";
    }
  }

  const getSalesTax = async () => {
    try {
      const requestData = {
        months: selectedMonth, 
        year: selectedYear, 
      };

      const response = await Post("salesTax", requestData);

      if (response && response.status === 200) {
        setTax(Array.isArray(response.data) ? response.data : [response.data]);
      } else {

      }
    } catch (err) {

      console.error("Error fetching sales tax:", err);
    }
  };

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    getSalesTax(); 
  }, [selectedMonth, selectedYear, showModal]); 

  const toggleModal = () => setShowModal(!showModal);
  const columns = [
    { header: "Collected Tax", field: "collected_tax" },
    { header: "Taxable Sales", field: "taxable_sales" },
    { header: "Mon Taxable Sales", field: "mon_taxable_sales" },
    { header: "Total Net Sales", field: "total_net_sales" },
    { header: "Prepaid Tax", field: "prepaid_tax" },
    { header: "Due Tax", field: "due_tax" },
  ];

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, index) => currentYear - index);

  useEffect(() => {
    setSelectedMonth(getCurrentDateInfo("month"));
    setSelectedYear(getCurrentDateInfo("year"));
  }, []);

  const handlePrepaidTaxSubmit = async (e) => {
    e.preventDefault(); 

    const formData = new FormData(e.target);

    const payload = Object.fromEntries(formData.entries());
    payload.store = storeid;
    payload.month = selectedMonth.toLowerCase();
    payload.year = selectedYear;

    const prepaidTaxAmount = parseFloat(payload.prepaid_tax);
    if (isNaN(prepaidTaxAmount) || prepaidTaxAmount < 0) {
      // toast.error("Please enter a valid prepaid tax amount.");
      handleToast({
        type:"ERROR",
        message:"Please enter a valid prepaid tax amount"
      })
      return;
    }
    await Post("prepaidTaxData", payload)
      .then((resp) => {
        setShowModal(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <>
      <ToastContainer />
      <div className="">
          <div className="responsive-box">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 className="mb-1">Sales Tax</h3>
              <button
                className="btn cus d-flex align-items-center"
                style={{
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "space-between", 
                  backgroundColor: "#FFAF32",
                  boxShadow: "none",
                  outline: "none",
                  width: "auto",
                  height: "42px",
                  padding: "8px 12px",
                  fontSize: "14px",
                  border: "none",
                  borderRadius: "10px",
                  color: "#000",
                  cursor: "pointer",
                  fontWeight: "bold",
                  gap: "8px", 
                }}
                onClick={toggleModal}
              >
                {" "}
                Add Prepaid Tax
                <img
                  src={prepaid}
                  alt="Bank Deposite Icon"
                  style={{ width: "20px", height: "20px", marginLeft: "18px" }}
                />
              </button>
            </div>

            <div className="d-flex mb-3" style={{ gap: "15px" }}>
              <select
                className="form-control"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                style={{
                  width: "140px",
                  textAlign: "center",
                  border: "1px solid #ccc",
                  padding: "5px 10px",
                  backgroundColor: "#ffffff",
                  borderRadius: "10px",
                  height: "40px",
                }}
              >
                {months.map((month, index) => (
                  <option key={index} value={month}>
                    {month}
                  </option>
                ))}
              </select>

              <select
                className="form-control"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                style={{
                  width: "140px",
                  textAlign: "center",
                  border: "1px solid #ccc",
                  padding: "5px 10px",
                  backgroundColor: "#ffffff",
                  borderRadius: "10px",
                  height: "40px",
                }}
              >
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            <SettingTable
              data={Array.isArray(tax) ? tax : []}
              columns={columns}
              showFooter={true}
              showAction={false}
              showExport={true}
              showFilter={false}

            />

            {showModal && (
              <div className="modal-overlay" onClick={toggleModal}>
                <div
                  className="modal-container"
                  onClick={(e) => e.stopPropagation()}
                  style={{ width: "740px", borderRadius: "20px" }}
                >
                  <div className="modal-header" style={{ border: "none" }}>
                    <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                      Add Prepaid Tax
                    </h5>
                    <img
                      src={CloseIcon} 
                      alt="Close"
                      width="34"
                      height="34"
                      onClick={toggleModal}
                    />

                    {}
                  </div>
                  <div className="modal-body">
                    <form onSubmit={handlePrepaidTaxSubmit}>
                      <div className="row align-items-center">
                        {}
                        <div className="col-md-2">
                          <select
                            className="form-control-borderless"
                            value={selectedMonth}
                            onChange={(e) => setSelectedMonth(e.target.value)}
                            style={{
                              width: "140px",
                              textAlign: "center",
                              border: "1px solid #ccc",
                              padding: "5px 10px",
                              backgroundColor: "#ffffff",
                              borderRadius: "10px",
                              height: "52px",
                              marginLeft: "10px",
                            }}
                          >
                            {months.map((month, index) => (
                              <option key={index} value={month}>
                                {month}
                              </option>
                            ))}
                          </select>
                        </div>

                        {}
                        <div className="col-md-2">
                          <select
                            className="form-control-borderless"
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(e.target.value)}
                            style={{
                              width: "140px",
                              textAlign: "center",
                              border: "1px solid #ccc",
                              padding: "5px 10px",
                              backgroundColor: "#ffffff",
                              borderRadius: "10px",
                              height: "52px",
                              marginLeft: "50px",
                            }}
                          >
                            {years.map((year) => (
                              <option key={year} value={year}>
                                {year}
                              </option>
                            ))}
                          </select>
                        </div>

                        {}
                        <div className="col-md-3">
                          <input
                            type="text"
                            className="form-control-borderless"
                            placeholder="Amount"
                            aria-label="Amount"
                            name="prepaid_amount"
                            style={{
                              width: "330px",

                              height: "52px",

                              marginLeft: "100px",
                            }}
                            onInput={(e) => {
                              e.target.value = e.target.value
                                .replace(/[^0-9.]/g, "") 
                                .replace(/^(\d*\.?\d{0,2}).*/g, "$1") 
                                .slice(0, 12); 
                            }}
                          />
                        </div>
                      </div>

                      <div
                        className="modal-footer"
                        style={{ border: "none", marginTop: "10px" }}
                      >
                        <button
                          type="button"
                          className="btn btn-secondary-outline"
                          onClick={toggleModal}
                          style={{
                            border: " 1px solid #282e26",
                            borderRadius: "50px",
                            width: "181px",
                            height: "45px",
                            fontWeight: "bold",
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn"
                          style={{
                            color: "white",
                            backgroundColor: "#282e26",
                            borderRadius: "50px",
                            width: "181px",
                            height: "45px",
                            fontWeight: "bold",
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

    </>
  );
}